import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function initApp() {
  // ─── Pre-process MSAL redirect callback BEFORE React mounts ───────────────
  // When Azure redirects back, the URL has #id_token=...&access_token=...
  // Or #error=... if there was an Azure-side failure (e.g. AADSTS900971)
  const hash = window.location.hash;
  if (hash && hash.length > 1) {
    const params = new URLSearchParams(hash.replace("#", ""));
    const idToken = params.get("id_token");
    const accessToken = params.get("access_token");
    const azureError = params.get("error");

    if (azureError) {
      // Azure returned an error (e.g. redirect URI not registered in Azure portal)
      const desc = params.get("error_description") || azureError;
      console.error("[MSAL] Azure error:", desc);
      window.history.replaceState({}, document.title, "/login?msal_error=1&reason=" + encodeURIComponent(azureError));
    } else if (idToken) {
      // Clean hash from URL immediately so React Router sees a clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
      try {
        const res = await fetch(`${BACKEND_URL}/api/auth/microsoft/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id_token: idToken, access_token: accessToken }),
        });
        const data = await res.json();

        if (data.status === "ok") {
          localStorage.setItem("valoriza_token", data.token);
          const user = {
            id: data.email,
            email: data.email,
            display_name: data.display_name,
            role: data.role,
            sedes: data.sedes ?? null,
          };
          localStorage.setItem("valoriza_user", JSON.stringify(user));
          window.history.replaceState({}, document.title, "/");
        } else if (data.status === "pending_rls") {
          sessionStorage.setItem("msal_pending", JSON.stringify({ email: data.email, name: data.name }));
          window.history.replaceState({}, document.title, "/login");
        } else if (data.status === "pending_sedes") {
          // User is approved in rls_rules but sedes need re-approval with correct codes
          sessionStorage.setItem("msal_pending_sedes", JSON.stringify({ email: data.email, name: data.name }));
          window.history.replaceState({}, document.title, "/login");
        }
      } catch (e) {
        console.error("[MSAL] Pre-render callback error:", e);
        window.history.replaceState({}, document.title, "/login?msal_error=1");
      }
    }
  }

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

initApp();
